module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gobierno/cabecera.jpg
// module id = 7zM0
// module chunks = 0